import { IGiangVienBan } from "../../../model/respone/category/IGiangVienBan";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eGiangVienBanActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IGiangVienBan[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IGiangVienBan | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IGiangVienBan,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};

export const eGiangVienBanActionIds = generateActionTypeIds(eGiangVienBanActionsObj, "GIANG_VIEN_BAN");
export type IGiangVienBanActionTypes = IGenericActionType<typeof eGiangVienBanActionsObj, "GIANG_VIEN_BAN">;
